import React from 'react'
import { string, bool, func, array, oneOfType, number } from 'prop-types'
import * as Styled from './ResultSorting.styles'

// component stack
import { Grid, Select, Tooltip } from 'components/atoms'
import { ORDER_RESULT_SORTING } from 'settings/app/constants'

const ResultSorting = (props) => {
  const {
    sorting,
    handlerSortChange,
    isLoading,
    activeSort,
    label,
    excludeCurrentValue,
    ...rest
  } = props

  // filter sorting array for key
  const getSortByKey = (sortKey) => {
    if (sortKey !== 'qsr_') {
      return { ...sorting.find((sortOption) => sortOption.key === sortKey) }
    }
    return sorting.filter((sortOption) => sortOption.key.includes(sortKey))
  }

  // reorder sorts by ORDER_RESULT_SORTING order
  const getSortedOptions = () => {
    const sortedOptions = []

    ORDER_RESULT_SORTING.forEach((sortKey) => {
      const sortOption = getSortByKey(sortKey)

      if (Array.isArray(sortOption) && sortOption.length > 0) {
        sortOption.forEach((option) => sortedOptions.push(option))
      } else if (Object.keys(sortOption).length > 1) {
        sortedOptions.push(sortOption)
      }
    })

    return sortedOptions
  }

  /**
   * get tip prop from current value (active selected element)
   * @returns {*|boolean}
   */
  // const getValueTooltip = value => ((value?.tip) ? value?.tip : false)

  return (
    <Styled.ResultSorting { ...rest }>
      <Grid item className='grid-item'>
        {label && <span style={{ paddingRight: 10 }}>{label}</span>}
        <Select
          id={ `result-sorting-${ activeSort }` }
          className='result-select'
          data-cy='result-sorting'
          handleSelect={ (sortBy) => {
            !isLoading && handlerSortChange(sortBy)
          } }
          // valueTooltip={getValueTooltip(sorting.find(sortOption => sortOption.key === activeSort))}
          value={ activeSort }
          options={ getSortedOptions(sorting).map((sortOption) => ({
            value: sortOption.key,
            label: sortOption.label,
            option: (
              <>
                <span className='sorting-label'>{sortOption.label}</span>
                {null !== sortOption.tip &&
                  'undefined' !== typeof sortOption.tip && (
                    <Tooltip
                      tooltipId={ `${ sortOption.key }-tip-id` }
                      infoIconId={ `${ sortOption.key }-info-icon` }
                      arrow='right'
                      dialogTitle={ sortOption.tip }>
                      {sortOption.tip}
                    </Tooltip>
                  )}
              </>
            ),
            tooltip:
              null !== sortOption.tip && 'undefined' !== typeof sortOption.tip
                ? {
                    tip: sortOption.tip,
                    title: sortOption.title,
                  }
                : false,
          })) }
          placeholder={ activeSort }
          context='resultSort'
          excludeCurrentValue={ excludeCurrentValue }
        />
      </Grid>
    </Styled.ResultSorting>
  )
}

ResultSorting.defaultProps = {
  isLoading: false,
  excludeCurrentValue: false,
}

ResultSorting.propTypes = {
  label: string,
  sorting: array.isRequired,
  handlerSortChange: func.isRequired,
  isLoading: bool,
  activeSort: oneOfType([string, number]).isRequired,
  excludeCurrentValue: bool,
}

export default ResultSorting
